(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const forms = document.querySelectorAll('[data-product-form]');

    forms.forEach((form) => {
      const select = form.querySelector('select[name="id"]');
      const submit = form.querySelector('.product-form__submit');

      if (!submit) return;

      if (!select) {
        submit.disabled = false;
        return;
      }

      submit.disabled = !select.value;

      select.addEventListener('change', () => {
        submit.disabled = !select.value;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const galleries = document.querySelectorAll('[data-product-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryInitialized === 'true') return;

      const slides = Array.from(
        gallery.querySelectorAll('[data-product-gallery-slide]')
      );

      const previousButton = gallery.querySelector(
        '[data-product-gallery-previous]'
      );

      const nextButton = gallery.querySelector(
        '[data-product-gallery-next]'
      );

      const currentCounter = gallery.querySelector(
        '[data-product-gallery-current]'
      );

      if (slides.length === 0) return;

      let currentIndex = 0;

      const formatNumber = (number) => {
        return String(number).padStart(2, '0');
      };

      const showSlide = (nextIndex) => {
        currentIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === currentIndex;

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        if (currentCounter) {
          currentCounter.textContent = formatNumber(currentIndex + 1);
        }
      };

      previousButton?.addEventListener('click', () => {
        showSlide(currentIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        showSlide(currentIndex + 1);
      });

      gallery.dataset.galleryInitialized = 'true';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
